module.exports = __webpack_public_path__ + "static/media/dids.c6dd351e.svg";